import { Component, Input, OnInit } from '@angular/core';
import { getPrettyZCStatus } from 'src/app/shared/enums/zoning-code-status';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-process-statistic-section',
    templateUrl: './process-statistic-section.component.html',
    styleUrls: ['./process-statistic-section.component.scss']
})
export class ProcessStatisticSectionComponent implements OnInit {
    @Input()
    process: ITaskModel;
    getPrettyZCStatus = getPrettyZCStatus;

    constructor() {}

    ngOnInit(): void {}
}
